import { Navigate, Route, Routes } from 'react-router-dom';

import { AdminLayout } from '@/components/layout/admin-layout';
import { RequireAuth } from '@/components/require-auth';
import { AssistantPage } from '@/pages/assistant';
import { AuditLogsPage } from '@/pages/audit-logs';
import { BannersPage } from '@/pages/banners';
import { BrandsPage } from '@/pages/brands';
import { CategoriesPage } from '@/pages/categories';
import { CustomerVerificationPage } from '@/pages/customer-verification';
import { CustomersPage } from '@/pages/customers';
import { DepositsPage } from '@/pages/deposits';
import { ForgotPasswordPage } from '@/pages/forgot-password';
import { InquiriesPage } from '@/pages/inquiries';
import { InventoryPage } from '@/pages/inventory';
import { LoginPage } from '@/pages/login';
import { DashboardPage } from '@/pages/dashboard';
import { OrdersPage } from '@/pages/orders';
import { PaymentsPage } from '@/pages/payments';
import { PlaceholderPage } from '@/pages/placeholder';
import { ProductsPage } from '@/pages/products';
import { ProfilePage } from '@/pages/profile';
import { SiteContentPage } from '@/pages/cms';
import { SeoPage } from '@/pages/seo';
import { SettingsPage } from '@/pages/settings';
import { UsersPage } from '@/pages/users';
import { QuotationsPage } from '@/pages/quotations';
import { ResetPasswordPage } from '@/pages/reset-password';
import { WarehousesPage } from '@/pages/warehouses';

/** Screens still awaiting their API phase, rendered through a shared shell. */
const PENDING_SCREENS = [
  {
    path: 'refunds',
    title: 'Refunds',
    description: 'Refund requests and processing',
    phase: 'Phase 8',
  },
  {
    path: 'shipping',
    title: 'Shipping',
    description: 'Shipments and carrier tracking',
    phase: 'Phase 8',
  },
];

export default function App() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      {/* Outside RequireAuth: the person using them cannot sign in. */}
      <Route path="/forgot-password" element={<ForgotPasswordPage />} />
      <Route path="/reset-password" element={<ResetPasswordPage />} />

      <Route element={<RequireAuth />}>
        <Route element={<AdminLayout />}>
          <Route index element={<DashboardPage />} />
          <Route path="orders" element={<OrdersPage />} />
          <Route path="payments" element={<PaymentsPage />} />
          <Route path="inquiries" element={<InquiriesPage />} />
          <Route path="quotations" element={<QuotationsPage />} />
          <Route path="ai-assistant" element={<AssistantPage />} />
          <Route path="users" element={<UsersPage />} />
          <Route path="products" element={<ProductsPage />} />
          <Route path="categories" element={<CategoriesPage />} />
          <Route path="brands" element={<BrandsPage />} />
          <Route path="inventory" element={<InventoryPage />} />
          <Route path="warehouses" element={<WarehousesPage />} />
          {/* Declared before `customers` so the more specific path wins. */}
          <Route path="customers/verification" element={<CustomerVerificationPage />} />
          <Route path="customers" element={<CustomersPage />} />
          <Route path="deposits" element={<DepositsPage />} />
          <Route path="settings" element={<SettingsPage />} />
          <Route path="audit-logs" element={<AuditLogsPage />} />
          <Route path="banners" element={<BannersPage />} />
          <Route path="cms" element={<SiteContentPage />} />
          <Route path="seo" element={<SeoPage />} />
          <Route path="profile" element={<ProfilePage />} />

          {PENDING_SCREENS.map((screen) => (
            <Route
              key={screen.path}
              path={screen.path}
              element={
                <PlaceholderPage
                  title={screen.title}
                  description={screen.description}
                  phase={screen.phase}
                />
              }
            />
          ))}

          <Route path="*" element={<Navigate to="/" replace />} />
        </Route>
      </Route>
    </Routes>
  );
}
